module.exports = __webpack_public_path__ + "2-42.jpg?5605fb4a305650ffd1c4ed1bc2502bc2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-42.jpg
// module id = 119
// module chunks = 0